import { Slider } from '../NarusMaterial/Slider'

import { makeAutobindedInput } from './FormBuilder'

const Slider_ = props => {
  const { onChange, inputPath, ...restProps } = props
  const handleOnChange = event => {
    if (onChange) {
      onChange(event.target.value)
    }
  }

  return (
    <Slider
      {...restProps}
      onChange={handleOnChange}
    />
  )
}

export const SliderInput = makeAutobindedInput(Slider_)
